import { useTranslation } from "react-i18next";
import React, { useState, Fragment, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Grid,
  Box,
  TextField,
  Button,
  Backdrop,
  CircularProgress,
  Typography,
  Dialog,
  IconButton,
  DialogContent,
  DialogTitle,
  DialogActions,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  useMediaQuery,
} from "@mui/material";
import apiRequest from "../../functions/api";
import { useTheme } from "@mui/material/styles";
import { useMessage } from "../../context/message-context";
import { DateTextField } from "../lib";
import MessageBox from "../shared/components/MessageBox";
import EditIcon from "@mui/icons-material/Edit";
import { ContentCopy, Fullscreen } from "@mui/icons-material";
import ECDatePicker from "../DatePicker/DatePicker";

function MasterDataBank(props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [vorsenden, setVorSenden] = useState(false);
  const [altiban, setAltIban] = useState("");
  const [altbank, setAltBank] = useState("");
  const [altbic, setAltBic] = useState("");
  const [altkontoinh, setAltKontoinh] = useState("");
  const [ibaneingabe, setIbaneingabe] = useState("");
  const [bank, setBank] = useState("");
  const [bic, setBic] = useState("");
  const [autoBic, setAutoBic] = useState("");
  const [autoBank, setAutoBank] = useState("");
  const [kontonummer, setKontonummer] = useState("");
  const [blz, setBLZ] = useState("");
  const { accessToken, client, bearbeitung, daten, reloadDaten } = props;
  const [stateReload, setStateReload] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [zeitraum, setZeitraum] = useState("");
  const [abwkontoinh, setAbwKontoInh] = useState("");
  const [ibanError, setIbanError] = useState("");
  const [beantragt, setBeantragt] = useState("");
  const [msgBox, setMsgBox] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const theme = useTheme();
  const { showErrorMessage, showSuccessMessage } = useMessage();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    setAltIban(daten.iban);
    setAltBank(daten.bank);
    setAltBic(daten.bic);
    setAltKontoinh(daten.kontoinh);
    if (daten.beantragt.status !== "") {
      // setBeantragt(daten.beantragt);
      setMsgBox(true);
    }
    // HoleDaten();
    // eslint-disable-next-line
  }, [daten]);


  const daten_speichern = () => {
    setIsLoading(true);
    const payload = {
      mandant: client,
      program: "LWEB02",
      statement: "IBAN_SPEICHERN",
      bankname: bank,
      iban: ibaneingabe,
      bic: bic,
      kontonummer: kontonummer,
      blz: blz,
      kontoinh: abwkontoinh,
      zeitraum: zeitraum,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, speichercb, errorCb);
  };
  const speichercb = (response) => {
    if (response.status === 200) {
      if (response.data.message === "ok") {
        setDialogOpen(false);
        setVorSenden(false);
       reloadDaten()
        showSuccessMessage(t("Bankverbindung wurde geändert."));
      } else {
        showErrorMessage(response.data.message);
      }
      setIsLoading(false);
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };
  const pruefeiban = () => {
    setIsLoading(true);
    const payload = {
      mandant: client,
      program: "LWEB02",
      statement: "IBAN_PRUEFEN",
      iban: ibaneingabe,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, pruefcb, errorCb);
  };
  const errorCb = () => {
    setIsLoading(false);
    showErrorMessage(t("Keine Internetverbindung"));
  };
  const ibanGeaendert = (neueIban) => {
    var formattedIban = neueIban.replace(/[^\w\s]/gi, "").replace(" ", "");
    if (formattedIban.length <= 34) {
      setIbaneingabe(formattedIban);
    }
    setBank("");
    setBic("");
    setBLZ("");
    setKontonummer("");
  };
  const pruefcb = (response) => {
    if (response.status === 200) {
      if (response.data.message === "ok") {
        setIbanError("");
        setBank(response.data.bankname);
        setAutoBank(response.data.bankname);
        setBic(response.data.bic);
        setAutoBic(response.data.bic);
        setBLZ(response.data.blz);
        setKontonummer(response.data.kontonummer);
        setZeitraum(response.data.zeitraum);
      } else {
        setIbanError(response.data.message);
        showErrorMessage(response.data.message);
        setBank("");
        setAutoBank("");
        setBic("");
        setAutoBic("");
        setBLZ("");
        setKontonummer("");
        setZeitraum("");
      }
      setIsLoading(false);
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };
  const handleBankChange = ({ target: { value } }) => {
    setBank(value);
  };
  const handleBicChange = ({ target: { value } }) => {
    setBic(value);
  };
  const messageBoxResult = (result) => {
    if (result === "NO") {
      setDialogOpen(false);
      setStateReload(!stateReload);
      // HoleDaten()
    }
    setMsgBox(false);
  };
  if (msgBox && dialogOpen) {
    return (
      <MessageBox
        open={msgBox}
        handleResponse={messageBoxResult}
        buttons="YESNO"
        text={"Wollen Sie die Änderung überschreiben?"}
        title={t("Es ist bereits eine Änderung der Bankverbindung vorhanden")}
        onClose={() => setMsgBox(false)}
      />
    );
  }

  const anzeigen = () => {
    return (
      <Fragment>
        <Grid item xs={12}>
          <Box p={1}>
            <TextField
              variant="outlined"
              label={t("Bankname")}
              value={bank}
              onChange={handleBankChange}
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              disabled={autoBank !== ""}
            />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box p={1}>
            <TextField
              variant="outlined"
              label={t("BIC")}
              value={bic}
              onChange={handleBicChange}
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              disabled={autoBic !== ""}
            />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box p={1}>
            <TextField
              variant="outlined"
              label={t("Abweichender Kontoinhaber")}
              helperText="*nur angeben, wenn Sie nicht der Kontoinhaber sind"
              value={abwkontoinh}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={(event) => {
                setAbwKontoInh(event.target.value);
              }}
              fullWidth
            />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box p={1}>
            <ECDatePicker mode="month-year" value={zeitraum} onChange={setZeitraum} label="Ab welchem Monat soll die Änderung erfolgen? " fullWidth />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Grid container justifyContent="flex-end">
            <Grid item>
              <Box p={1}>
                <Button onClick={() => setDialogOpen(false)}>{t("Zurück")}</Button>
                <Button variant="contained" color="primary" disabled={ibanError !== "" || bank === "" || bic === ""} onClick={() => setVorSenden(true)}>
                  {t("Weiter")}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Fragment>
    );
  };
  const handleCopy = (copyData) => {
    navigator.clipboard.writeText(copyData);
    showSuccessMessage("Kopieren erfolgreich");
  };
  const dialogClose = () => {
    setDialogOpen(false);
  };

  return (
    <>
      <Grid item xs={12}>
        <Paper>
          {daten.beantragt?.status && (
            <>
              <Typography color={"red"}>
                {daten.beantragt.status === "A" ? "Änderung bereits beantragt" : "Änderung genehmigt und zur Übernahme vorgemerkt:"}
              </Typography>
              <Typography color={"red"}>
                IBAN: {daten.beantragt.IBAN} BIC:{daten.beantragt.BIC}
              </Typography>
            </>
          )}
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow key="bankdaten">
                  <TableCell width="125%">
                    <Typography>{t("Aktuelle Bankdaten")}</Typography>
                  </TableCell>
                  <TableCell></TableCell>
                  <TableCell align="right">
                    {bearbeitung && (
                      <IconButton
                        onClick={(e) => {
                          e.stopPropagation();
                          if (daten.beantragt?.status && daten.beantragt.status !== "A") {
                            showErrorMessage(
                              t(
                                "Es ist bereits eine Änderung in Bearbeitung. Bitte warten Sie, bis diese übernommen wurde, bevor Sie einen neuen Änderungsantrag stellen",
                              ),
                            );
                          } else {
                            setDialogOpen(true);
                          }
                        }}
                      >
                        <EditIcon />
                      </IconButton>
                    )}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow key="iban">
                  <TableCell align="left">
                    <Typography>{t("IBAN")}</Typography>
                    {fullScreen && <Typography variant="body2">{altiban}</Typography>}
                  </TableCell>
                  <TableCell>
                    {!fullScreen && (
                      <Typography component={"div"} variant="body2">
                        {altiban}
                      </Typography>
                    )}
                  </TableCell>
                  <TableCell align="right">
                    <IconButton color="primary" onClick={() => handleCopy(altiban)}>
                      <ContentCopy />
                    </IconButton>
                  </TableCell>
                </TableRow>

                <TableRow key="bankname">
                  <TableCell align="left">
                    <Typography>{t("Bankname")}</Typography>
                    {fullScreen && <Typography variant="body2">{altbank}</Typography>}
                  </TableCell>
                  <TableCell align="right">{!fullScreen && <Typography variant="body2">{altbank}</Typography>}</TableCell>
                  <TableCell align="right">
                    <IconButton color="primary" onClick={() => handleCopy(altbank)}>
                      <ContentCopy />
                    </IconButton>
                  </TableCell>
                </TableRow>

                <TableRow key="bic">
                  <TableCell align="left">
                    <Typography>{t("BIC")}</Typography>
                    {fullScreen && <Typography variant="body2">{altbic}</Typography>}
                  </TableCell>
                  <TableCell align="right">{!fullScreen && <Typography variant="body2">{altbic}</Typography>}</TableCell>
                  <TableCell align="right">
                    <IconButton color="primary" onClick={() => handleCopy(altbic)}>
                      <ContentCopy />
                    </IconButton>
                  </TableCell>
                </TableRow>

                {altkontoinh && (
                  <TableRow key="bic">
                    <TableCell align="left">
                      <Typography variant="body2">{t("Kontoinhaber")}</Typography>
                    </TableCell>
                    <TableCell align="right">
                      <Typography variant="body2">{altkontoinh}</Typography>
                    </TableCell>
                    <TableCell align="right">
                      <IconButton color="primary" onClick={() => handleCopy(altkontoinh)}>
                        <ContentCopy />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Grid>

      <Dialog
        sx={{ "& .MuiDialog-paper": { width: "80%", maxHeight: 735 } }}
        maxWidth="md"
        open={dialogOpen}
        fullScreen={fullScreen}
        onClose={() => dialogClose()}
      >
        <DialogTitle>{t("Bankverbindung ändern")}</DialogTitle>
        <DialogContent dividers>
          {!vorsenden && (
            <Grid container justifyContent="center">
              <Grid item xs={12} lg={6}>
                <Box p={1}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <Typography variant="h6" align="left" color="primary">
                        {t("Alte Bankdaten")}
                      </Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography variant="body1" align="left">
                        {t("IBAN")}
                      </Typography>
                    </Grid>
                    <Grid item xs={8}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                          ...(fullScreen && {
                            "@media (min-width:200px)": {
                              flexDirection: "row",
                              flexWrap: "wrap",
                            },
                          }),
                        }}
                      >
                        <Typography
                          sx={{
                            ...(fullScreen && {
                              wordBreak: "break-all",
                              overflowWrap: "break-word",
                              textOverflow: "ellipsis",
                            }),
                          }}
                          component={"div"}
                          variant="body2"
                        >
                          {altiban}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography variant="body1" align="left">
                        {t("Bank")}
                      </Typography>
                    </Grid>
                    <Grid item xs={8}>
                      <Typography variant="body1" align="left">
                        {altbank}
                      </Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography variant="body1" align="left">
                        {t("BIC")}
                      </Typography>
                    </Grid>
                    <Grid item xs={8}>
                      <Typography variant="body1" align="left">
                        {altbic}
                      </Typography>
                    </Grid>
                    {altkontoinh && (
                      <>
                        <Grid item xs={4}>
                          <Typography variant="body1" align="left">
                            {t("Kontoinhaber")}
                          </Typography>
                        </Grid>
                        <Grid item xs={8}>
                          <Typography variant="body1" align="left">
                            {altkontoinh}
                          </Typography>
                        </Grid>
                      </>
                    )}
                  </Grid>
                </Box>
              </Grid>
              <Grid item xs={12} lg={6}>
                <Grid container>
                  <Grid item xs={12}>
                    <Box p={1}>
                      <Typography variant="h6" align="left" color="primary">
                        {t("Neue Bankdaten")}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Box p={1}>
                      <TextField
                        id="iban"
                        label={t("Neue IBAN")}
                        variant="outlined"
                        value={ibaneingabe}
                        error={ibanError !== ""}
                        onBlur={() => {
                          if (bank === "" || bic === "") pruefeiban();
                        }}
                        onKeyUp={(e) => {
                          if (e.code === "Enter") pruefeiban();
                        }}
                        helperText={ibanError}
                        onChange={(event) => {
                          ibanGeaendert(event.target.value);
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        fullWidth
                      />
                    </Box>
                  </Grid>
                  {anzeigen()}
                </Grid>
              </Grid>
            </Grid>
          )}
          {vorsenden && (
            <Grid container>
              <Grid item xs={12} md={6}>
                <Box p={1}>
                  <Typography align="left" color="primary">
                    {t("Bisherige Bankdaten")}
                  </Typography>
                  <Typography align="left">{"IBAN: " + altiban}</Typography>
                  <Typography align="left">{"Bankname: " + altbank}</Typography>
                  <Typography align="left">{"BIC: " + altbic}</Typography>
                  {altkontoinh && <Typography align="left">{"Abweichender Kontoinhaber: " + altkontoinh}</Typography>}
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box p={1}>
                  <Typography align="left" color="primary">
                    {"Neue Bankdaten"}
                  </Typography>
                  <Typography align="left">{"IBAN: " + ibaneingabe}</Typography>
                  <Typography align="left">{"Bankname: " + bank}</Typography>
                  <Typography align="left">{"BIC: " + bic}</Typography>
                  {abwkontoinh && <Typography align="left">{"Abweichender Kontoinhaber: " + abwkontoinh}</Typography>}
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box p={1}>
                  <Grid container justifyContent="flex-end">
                    <Grid item>
                      <Box ml={1}>
                        <Button color="primary" variant="text" fullWidth onClick={() => setVorSenden(false)}>
                          {"Zurück"}
                        </Button>
                      </Box>
                    </Grid>
                    <Grid item>
                      <Box ml={1}>
                        <Button variant="contained" color="primary" fullWidth onClick={() => daten_speichern()}>
                          {"Speichern"}
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          )}
        </DialogContent>
      </Dialog>

      <Backdrop open={isLoading} style={{ color: theme.palette.common.white, zIndex: theme.zIndex.drawer + 1 }}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}
export default MasterDataBank;
